import { useCallback, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

const PAGE_PARAM = 'page';
const DEFAULT_PAGE = 1;

export function usePageParam(): [number, (page: number) => void] {
    const [searchParams, setSearchParams] = useSearchParams();

    const page = useMemo(() => {
        const raw = Number(searchParams.get(PAGE_PARAM));
        return Number.isInteger(raw) && raw >= 1 ? raw : DEFAULT_PAGE;
    }, [searchParams]);

    const setPage = useCallback(
        (nextPage: number) => {
            setSearchParams(
                (previous) => {
                    const next = new URLSearchParams(previous);
                    if (nextPage <= DEFAULT_PAGE) {
                        next.delete(PAGE_PARAM);
                    } else {
                        next.set(PAGE_PARAM, String(nextPage));
                    }
                    return next;
                },
                { replace: true },
            );
        },
        [setSearchParams],
    );

    return [page, setPage];
}
